export const endStream = () => {
    if (!window.mediaStream) return;
    window.mediaStream.getTracks().forEach((track) => {
        track.stop();
    });
}